module.exports = __webpack_public_path__ + "static/media/NOP - Sunrise Stayner.dcd4b06c.pdf";